const objectFit = {
    mounted() {
        this.$nextTick(() => {
            if ('objectFit' in document.documentElement.style === false) {
                const container = this.$refs.fit
                if (container) {
                    const image = container.querySelector('img')
                    const domRect = container.getBoundingClientRect()
                    const ratio = domRect.height / domRect.width

                    image.style.position = 'absolute'
                    image.style.top = '50%'
                    image.style.left = '50%'
                    image.style.width = ratio < 1 ? 'auto' : '100%'
                    image.style.height = ratio > 1 ? 'auto' : '100%'
                    image.style.transform = 'translateX(-50%) translateY(-50%)'

                    container.style.overflow = 'hidden'
                }
            }
        })
    }
}

export default objectFit
